<template>
  <a-form-item class="label__required" label="Obligatorio:">
    <a-switch :checked="required" size="small" @change="handleChange" />
  </a-form-item>
</template>
<script setup lang="ts">
defineProps<{
  required: boolean;
}>();

const emit = defineEmits<{
  (e: "update:required", required: boolean): void;
}>();

const handleChange = (checked: boolean) => emit("update:required", checked);
</script>

<style scoped lang="sass">
.label__required
  flex-direction: row !important
  gap: 5px
  justify-content: flex-end
</style>

<style>
.label__required > .ant-form-item-label {
  padding: 0 !important;
  display: flex;
  align-items: center;
}

.label__required > .ant-form-item-control {
  flex-grow: inherit;
}
</style>
